// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_RECENT_POSTS = "Najnov\u0161ie ot\u00e1zky z poradne";
export const FORUM_RELATED_DISCUSSIONS = "S\u00favisiace diskusie";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskusie";
export const RELATED_DISCUSSIONS_IN_FORUM = "S\u00favisiace diskusie vo f\u00f3re";
export const STROLLER_MORE_REVIEWS = "\u010eal\u0161ie hodnotenia";
export const TO_REVIEW_CENTRE = "do Centra recenzi\u00ed";
export const WIKI_EXPERIENCES_WITH_title = "Hodnotenia a sk\u00fasenosti %(title)s";
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prv\u00e1 a nap\u00ed\u0161 hodnotenie";
export const YOUTUBE_MK_TITLE = "YouTube Modr\u00fd kon\u00edk";
